<template>
  <v-container class="mt-4">
    <v-progress-linear v-if="isLoading" indeterminate color="primary"></v-progress-linear>
    
    <div class="dateBox mb-4">
      <p class="year">{{wishPeriod?.title}}</p>
      <p class="year">{{wishPeriod?.startDate.getFullYear()}}</p>
      <p class="date">{{ dateTimeString }}</p>
    </div>
    
    <v-calendar :expanded="expanded"
                ref="calendar"
                borderless
                :columns="columns"
                :min-date=wishPeriod?.startDate
                :max-date=wishPeriod?.endDate
                :attributes="attributes"/>

    <v-row>
      <v-col cols="5" class="text-start">Bemerkung:</v-col>
      <v-col cols="7" class="text-start">
        {{ wishData?.bemerkung}}
      </v-col>
    </v-row>
    <div>
      <v-row>
        <v-col cols="5" class="text-start">Abgeschickt:</v-col>
        <v-col cols="7" class="text-start">
          {{ wishData?.finished ? '✔️' : '' }}
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script lang="ts">
import {computed, onMounted, ref} from "vue";
import {useScreens} from "vue-screen-utils";
import {useRoute} from "vue-router";
import {useStore} from "@/store";
import {GetWishPeriod} from "@/data/wishPeriod";
import {GetWishData} from "@/data/wishData";

export default {
  name: 'WunschdienstInfoView',
  setup() {
    const route = useRoute();
    const store = useStore();
    const periodId = route.params.wunschdienstId;
    const employ = ref(store.state.userData.employData);
    const userId = route.params.userId;
    const calendar = ref(null);
    const attributes = ref([
      {
        key: '1', //Früh
        highlight: {
          color: 'orange',
          fillMode: 'solid',
          contentClass: 'italic',
        },
        dates:  [],
      },
      {
        key: '2',  //Mittel
        highlight: {
          color: 'pink',
          fillMode: 'solid',
          contentClass: 'italic',
        },
        dates: [],
      },
      {
        key: '3', //Spät
        highlight: {
          color: 'purple',
          fillMode: 'solid',
          contentClass: 'italic',
        },
        dates: [],
      },
      {
        key: '5', //Geteilt
        highlight: {
          color: 'teal',
          fillMode: 'solid',
          contentClass: 'italic',
        },
        dates: [],
      },
      {
        key: '4', //NE
        highlight: {
          color: 'blue',
          fillMode: 'solid',
          contentClass: 'italic',
        },
        dates: [],
      },
      {
        key: '10', //Frei
        highlight: {
          color: 'green',
          fillMode: 'solid',
          contentClass: 'italic',
        },
        dates: [],
      },
      {
        key: 'urlaub',
        highlight: {
          color: 'lightgreen',
          fillMode: 'solid',
          contentClass: 'italic',
        },
        dates: [],
      },
    ]);
    const { mapCurrent } = useScreens({
      xs: '0px',
      sm: '640px',
      md: '768px',
      lg: '1024px',
    });
    
    const columns = mapCurrent({ lg: 2 }, 1);
    const expanded = mapCurrent({ sm: false, lg: true }, true);
    const wishPeriod = ref<WishPeriod | null>(null);
    const wishData = ref<WishData | null>(null);
    const isLoading = ref(false);

    const dateTimeString = computed(() => {
      if(wishPeriod.value === null)
        return '';

      return wishPeriod.value.startDate.toLocaleDateString('de-DE') + " - " + wishPeriod.value.endDate.toLocaleDateString('de-DE');
    });
    
    onMounted(async () => {
      wishPeriod.value = await GetWishPeriod(periodId as string);
      wishData.value = await GetWishData(periodId as string,  employ.value?.emplno as string);

      wishData.value.dates.forEach(dates => {
        const attribute = attributes.value.find(attr => attr.key == dates.shift.toString());
        if (attribute) {
          attribute.dates.push(dates.date);
        }
      });

      if (calendar.value) {
        await calendar.value.focusDate(wishPeriod.value.startDate);
      }
    });
    
    return {attributes, columns, expanded, wishPeriod, calendar, periodId, userId, isLoading, dateTimeString, wishData};
  }
}
</script>

<style scoped>

.dateBox{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100px;
  background: #B40055;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
}

.year{
  font-size: 18px;
  color: white;
  text-align: center;
  margin-bottom: 3px;
}

.date{
  font-size: 24px;
  color: white;
  text-align: center;
}
</style>